/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
//import Card from "@mui/material/Card";

import parse from "html-react-parser";
import moment from "moment";

import {
  Add,
  CalendarMonth,
  Close,
  Dashboard,
  DashboardCustomize,
  Delete,
  East,
  EventBusy,
  Groups2,
  NotificationsNone,
  Search,
  WorkOutline,
} from "@mui/icons-material";
//import ApiCalls from "services/flick_erp_api_call";
import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
//import MDAvatar from "components/MDAvatar";
import burceMars from "assets/images/bruce-mars.jpg";
import divyanshu from "assets/divyanshu.png";
import {
  Autocomplete,
  Avatar,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  Grid,
  IconButton,
  InputAdornment,
  Popover,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDEditor from "components/MDEditor";
import MDTypography from "components/MDTypography";
import Calendar from "examples/Calendar";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import ApiCalls from "services/flick_erp_api_call";
import { base_url } from "services";
import { useMaterialUIController } from "context";

const decodeHtml = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const stripHtml = (value = "") => value.replace(/<\/?[^>]+(>|$)/g, "");

const statusToColor = {
  approved: "success",
  pending: "warning",
  rejected: "error",
};

const normalizeImage = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  return `${base_url}/${src}`;
};

const getLeaveEmployeeName = (entry = {}) => {
  const firstName =
    entry?.employee__user__firstname ||
    entry?.employee?.user?.firstname ||
    entry?.employee?.firstname ||
    "";
  const lastName =
    entry?.employee__user__lastname ||
    entry?.employee?.user?.lastname ||
    entry?.employee?.lastname ||
    "";
  const fullName = `${firstName} ${lastName}`.trim();

  if (fullName && fullName.toLowerCase() !== "employees") {
    return fullName;
  }

  return entry?.employee_name || entry?.employee?.fullname || entry?.fullname || "Employee";
};

const getDashboardEmployeeKey = (entry = {}) =>
  entry?.employee__user ||
  entry?.employee?.user?.id ||
  entry?.employee_id ||
  entry?.employee;

const flattenHierarchy = (nodes = [], level = 0) =>
  nodes.flatMap((node) => [
    {
      id: node.id,
      fullname: node.fullname,
      img: node.img,
      level,
    },
    ...flattenHierarchy(node.children || [], level + 1),
  ]);

function EmployeeDashboard({ permissions, modulePermissions }) {
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const palette = theme.palette;
	const navigate = useNavigate();
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const [noticeBoardList, setNoticeBoardList] = useState([]);
  const [noticeDialogOpen, setNoticeDialogOpen] = useState(false);
  const [addNoticeDialogOpen, setAddNoticeDialogOpen] = useState(false);
  const [addNoticePayload, setAddNoticePayload] = useState({});
  const [employees, setEmployees] = useState([]);
  const [holidayEvents, setHolidayEvents] = useState([]);
  const [orgHierarchy, setOrgHierarchy] = useState([]);
  const [userDashboard, setUserDashboard] = useState({});
  const [noticeDialogData, setNoticeDialogData] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [leaveAnchorEl, setLeaveAnchorEl] = useState(null);
  const [wfhAnchorEl, setWFHAnchorEl] = useState(null);
  const [upcomingLeaveAnchorEl, setUpcomingLeaveAnchorEl] = useState(null);
  const [hierarchyDrawerOpen, setHierarchyDrawerOpen] = useState(false);
	const [expandedNodes, setExpandedNodes] = useState({});

  const ui = {
    card: darkMode ? palette.background.card : colors.white.main,
    soft: darkMode ? palette.background.muted : colors.background.elevated,
    softAlt: darkMode ? rgba(palette.white.main, 0.04) : colors.info.light,
    border: darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.secondary.main, 0.12),
    title: darkMode ? palette.text.focus : colors.dark.main,
    body: darkMode ? palette.text.main : colors.secondary.main,
    pageHeader: darkMode
      ? `linear-gradient(180deg, ${rgba(palette.background.card, 0.98)} 0%, ${rgba(
          palette.background.muted,
          0.95
        )} 100%)`
      : `linear-gradient(180deg, ${rgba(colors.light.main, 0.94)} 0%, ${rgba(colors.white.main, 0.98)} 100%)`,
    summaryCard: darkMode
      ? `linear-gradient(135deg, ${rgba(palette.background.muted, 0.96)} 0%, ${rgba(
          palette.background.card,
          0.98
        )} 100%)`
      : `linear-gradient(135deg, ${rgba(colors.primary.main, 0.98)} 0%, ${rgba(colors.info.focus, 0.95)} 55%, ${rgba(colors.info.main, 0.88)} 100%)`,
    summaryLabel: darkMode ? palette.text.main : colors.info.light,
    summaryValue: darkMode ? palette.text.focus : colors.info.light,
    summaryMeta: darkMode ? palette.text.main : colors.white.main,
    iconSurface: darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.info.light, 0.45),
  };

  useEffect(() => {
    getEmployee();
    getNoticeBoards();
    getOrganisationHierarchy();
    getUserDashboard();
    getDashboardHolidays();
  }, []);

  async function getNoticeBoards() {
    const res = await ApiCalls.getNoticeBoards();
    if (res?.success && res.code === 200) {
      setNoticeBoardList(res.data || []);
    }
  }
  // get employees list
  async function getEmployee() {
    const res = await ApiCalls.getBaseEmployeesList("?status=active");
    if (res?.success && res.code === 200) {
      setEmployees(res.data || []);
    }
  }

  async function getDashboardHolidays() {
    try {
      const employeeRes = await ApiCalls.getEmployee(loggedUser.employee_id);
      if (!(employeeRes?.success && employeeRes.code === 200)) {
        return;
      }

      const employeeBranch = Number(employeeRes.data?.branch);
      if (!employeeBranch) {
        return;
      }

      const holidayRes = await ApiCalls.getholidaysList(moment().year());
      if (!(holidayRes?.success && holidayRes.code === 200)) {
        return;
      }

      const branchHolidays = (holidayRes.data || [])
        .filter((holiday) => Array.isArray(holiday.branch) && holiday.branch.includes(employeeBranch))
        .map((holiday) => ({
          id: holiday.id,
          title: holiday.name,
          date: holiday.date,
          holidayType: holiday.type,
          milestoneType: "holiday",
        }));

      setHolidayEvents(branchHolidays);
    } catch (error) {
      console.error("Error fetching dashboard holidays:", error);
    }
  }
  // get organisation hierarchy
  async function getOrganisationHierarchy() {
    const res = await ApiCalls.getOrganisationHierarchyList();
    if (res?.success && res.code === 200) {
      setOrgHierarchy(res.data || []);
    }
  }
  // get user dashboard
  async function getUserDashboard() {
    const res = await ApiCalls.getUserDashboard();
    if (res?.success && res.code === 200) {
      setUserDashboard(res.data || {});
    }
  }

  async function postReadBy(id) {
    const user = JSON.parse(localStorage.getItem("user"));
    const payload = {
      org: user.org_id,
      notishboard: id,
      reads_by: user.employee_id,
    };

    await ApiCalls.postNoticeBoardRead(payload, false);
    getNoticeBoards();
  }

  async function postNotice() {
    const user = JSON.parse(localStorage.getItem("user"));
    const payload = {
      ...addNoticePayload,
      org: user.org_id,
      added_by: user.employee_id,
    };

    const res = await ApiCalls.postNoticeBoard(payload, false);
    if (res?.success && res.code === 201) {
      setAddNoticePayload({});
      setAddNoticeDialogOpen(false);
      getNoticeBoards();
    }
  }

  async function deleteNotice(id) {
    await ApiCalls.deleteNoticeBoard(id);
    getNoticeBoards();
  }

  const employeeLookup = useMemo(() => {
    const map = new Map();
    employees.forEach((employee) => {
      map.set(employee?.user?.id, employee);
    });
    return map;
  }, [employees]);

  const resolveDashboardEmployee = (entry = {}) => {
    const employeeFromList = employeeLookup.get(getDashboardEmployeeKey(entry));

    if (employeeFromList) {
      return employeeFromList;
    }

    if (entry?.employee?.user || entry?.employee?.fullname || entry?.employee?.img) {
      return entry.employee;
    }

    return {
      fullname: getLeaveEmployeeName(entry),
      img: entry?.employee__img || entry?.img || "",
      user: {
        firstname: entry?.employee__user__firstname || "",
        lastname: entry?.employee__user__lastname || "",
      },
    };
  };

  const filteredNotices = useMemo(() => {
    if (!searchValue.trim()) return noticeBoardList;
    const query = searchValue.toLowerCase();

    return (noticeBoardList || []).filter((notice) => {
      const title = (notice?.titile || "").toLowerCase();
      const body = decodeHtml(stripHtml(notice?.body || "")).toLowerCase();
      return title.includes(query) || body.includes(query);
    });
  }, [noticeBoardList, searchValue]);

  //const hierarchyItems = useMemo(() => flattenHierarchy(orgHierarchy), [orgHierarchy]);

const renderTree = (nodes, level = 0) => {
  return nodes.map((employee) => {
    const isExpanded = expandedNodes[employee.id];

    return (
      <MDBox key={employee.id}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            px: 1.25,
            py: 1.1,
            borderRadius: "18px",
            backgroundColor:
              level === 0
                ? ui.softAlt
                : ui.card,
            border: `1px solid ${ui.border}`,
            ml: level * 2,
            cursor: employee.children?.length ? "pointer" : "default",
          }}
          onClick={() => employee.children?.length && toggleNode(employee.id)}
        >
          <Stack direction="row" spacing={1.1} alignItems="center" minWidth={0}>
            
            {/* 👉 Expand/Collapse Icon */}
            {employee.children?.length > 0 && (
              <MDBox sx={{ fontSize: 14, width: 16 }}>
                {isExpanded ? "▼" : "▶"}
              </MDBox>
            )}

            <Avatar
              src={normalizeImage(employee.img)}
              sx={{ width: 34, height: 34 }}
            >
              {employee.fullname?.charAt(0)}
            </Avatar>

            <MDBox>
              <Typography variant="body2" fontWeight="bold" noWrap sx={{ color: ui.title }}>
                {employee.fullname}
              </Typography>
              <Typography variant="caption" sx={{ color: ui.body }}>
                {employee.designation}
              </Typography>
            </MDBox>
          </Stack>
        </Stack>

        {/* 👇 CHILDREN RENDER ONLY IF EXPANDED */}
        {isExpanded &&
          employee.children?.length > 0 &&
          renderTree(employee.children, level + 1)}
      </MDBox>
    );
  });
};

const toggleNode = (id) => {
  setExpandedNodes((prev) => ({
    ...prev,
    [id]: !prev[id],
  }));
};

useEffect(() => {
  const initial = {};

  const setDefaults = (nodes) => {
    nodes.forEach((node) => {
      initial[node.id] = true; // 👈 open by default
      if (node.children) setDefaults(node.children);
    });
  };

  setDefaults(orgHierarchy);
  setExpandedNodes(initial);
}, [orgHierarchy]);

  const todayKey = moment().format("YYYY-MM-DD");
  const todayLeaves = (userDashboard?.current_leaves || []).filter((entry) =>
    moment(todayKey).isBetween(
      moment(entry?.start_date).format("YYYY-MM-DD"),
      moment(entry?.end_date).format("YYYY-MM-DD"),
      "day",
      "[]"
    )
  );
  const todayWFHEmployees = userDashboard?.wfh_employees || [];
  const upcomingLeaves = (userDashboard?.upcoming_leaves_next_8_days || []).filter(
    (entry) => moment(entry?.start_date).format("YYYY-MM-DD") !== todayKey
  );

  const totalEmployees = employees.length;
  const leaveCount = todayLeaves.length;
  const wfhCount = todayWFHEmployees.length || 0;
  const upcomingLeaveCount = upcomingLeaves.length || 0;

  const summaryCards = [
    {
      label: "Employees",
      value: totalEmployees,
      meta: `${Math.max(totalEmployees - leaveCount, 0)} available now`,
      icon: <Groups2 sx={{ color: colors.light.main, fontSize: 18 }} />,
      onClick: () => navigate("/employee/employees"),
    },
    {
      label: "On Leave",
      value: leaveCount,
      meta: "People currently away",
      icon: <EventBusy sx={{ color: colors.light.main, fontSize: 18 }} />,
      onClick: (event) => setLeaveAnchorEl(event.currentTarget),
    },
    {
      label: "On WFH",
      value: wfhCount,
      meta: "Remote for the day",
      icon: <WorkOutline sx={{ color: colors.light.main, fontSize: 18 }} />,
      onClick: (event) => setWFHAnchorEl(event.currentTarget),
    },
    {
      label: "Upcoming Leaves",
      value: upcomingLeaveCount,
      meta: "Next eight days",
      icon: <CalendarMonth sx={{ color: colors.light.main, fontSize: 18 }} />,
      onClick: (event) => setUpcomingLeaveAnchorEl(event.currentTarget),
    },
  ];

  const openNoticeDialog = (notice) => {
    setNoticeDialogData(notice);
    setNoticeDialogOpen(true);

    if (!notice?.read_by?.includes(loggedUser?.employee_id)) {
      postReadBy(notice.id);
    }
  };

	const colorCodeComponent = (status) => {
    return (
      <MDBox display="flex" alignItems="center">
        <MDBox
          height={8}
          width={8}
          style={{
            borderRadius: "2px",
            backgroundColor:
              status == "pending"
                ? "#ffde05"
                : status == "approved"
                ? "green"
                : "red",
          }}
        ></MDBox>
        <MDTypography
          textTransform="capitalize"
          style={{
            fontSize: "10px",
            fontWeight: "bold",
          }}
        >
          &nbsp; {status}
        </MDTypography>
      </MDBox>
    );
  };

  const renderEmployeePopover = (entries = [], selector, options = {}) => (
    <MDBox sx={{ width: 320, maxWidth: "88vw", p: 1.25 }}>
      {entries.length ? (
        <Stack spacing={1}>
          {entries.map((entry, index) => {
            const employee = selector(entry);
            const primaryText = employee?.user?.firstname
              ? `${employee.user.firstname} ${employee.user.lastname || ""}`.trim()
              : employee?.fullname || "Employee";
            const secondaryText = options.secondaryText
              ? options.secondaryText(entry, employee)
              : employee?.designation || employee?.user?.email || "";

            return (
              <MDBox
                key={`${employee?.user?.id || employee?.id || index}`}
                sx={{
                  px: 1.1,
                  py: 0.9,
                  borderRadius: "16px",
                  backgroundColor: ui.soft,
                  border: `1px solid ${ui.border}`,
                }}
              >
                <Stack direction="row" spacing={1.1} alignItems="center">
                  <MDAvatar
                    src={normalizeImage(employee?.img)}
                    alt="employee-avatar"
                    size="sm"
                    sx={{
                      border: `2px solid ${darkMode ? palette.background.card : colors.white.main}`,
                      boxShadow: `0 8px 20px ${rgba(colors.dark.main, 0.12)}`,
                      flexShrink: 0,
                    }}
                  />
                  <MDBox sx={{ minWidth: 0 }}>
                    <MDTypography
                      variant="body2"
                      sx={{ color: ui.title, fontWeight: 700 }}
                      noWrap
                    >
                      {primaryText}
                    </MDTypography>
                    {secondaryText ? (
                      <MDTypography
                        variant="caption"
                        sx={{ color: ui.body, display: "block" }}
                        noWrap
                      >
                        {secondaryText}
                      </MDTypography>
                    ) : null}
                  </MDBox>
                </Stack>
              </MDBox>
            );
          })}
        </Stack>
      ) : (
        <MDBox
          sx={{
            minHeight: 120,
            display: "grid",
            placeItems: "center",
            borderRadius: "16px",
            backgroundColor: ui.soft,
            border: `1px solid ${ui.border}`,
          }}
        >
          <MDTypography variant="body2" sx={{ color: ui.body }}>
            No employees to show.
          </MDTypography>
        </MDBox>
      )}
    </MDBox>
  );

  return (
    <>
		<Card>
      <MDBox 
					p={{ xs: 2.5, md: 3.5 }}
					sx={{
						borderBottom: `1px solid ${ui.border}`,
						background: ui.pageHeader,
					}}
			>
        <Stack
          direction={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", lg: "center" }}
          spacing={2}
          mb={3}
        >
          <MDBox style = {{ display: "flex", alignItems: "center", gap: 12 }}>
						<MDBox
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "16px",
                      display: "grid",
                      placeItems: "center",
                      background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
                      color: colors.white.main,
                    }}
                  >
                    <DashboardCustomize />
                  </MDBox>
						<MDBox>
            <MDTypography variant="h5" sx={{ color: ui.title }}>Dashboard</MDTypography>
            <MDTypography variant="body2" sx={{ color: ui.body }}>
              Fast, clear, and role-ready ERP workflows.
            </MDTypography>
						</MDBox>
          </MDBox>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.25}
            width={{ xs: "100%", lg: "auto" }}
            alignItems={{ xs: "stretch", sm: "center" }}
          >
						{/*<TextField
						label="Search announcements and updates..."
						variant="outlined"
						fullWidth
						value={searchValue}
						onChange={(event) => setSearchValue(event.target.value)}
						sx={{ mb: 2 }}
					/>*/}
            <MDBox
              sx={{
                px: 2,
                py: 1.15,
                borderRadius: "14px",
                backgroundColor: colors.warning.main,
                border: `1px solid ${ui.border}`,
                color: colors.white.main,
                fontWeight: 700,
                fontSize: "0.875rem",
                whiteSpace: "nowrap",
              }}
            >
              {moment().format("DD MMM YYYY")}
            </MDBox>
							<MDButton
								color="info"
								fullWidth
								onClick={() => setHierarchyDrawerOpen(true)}
								sx={{
									height: 42,
									px: 2.25,
									borderRadius: "14px",
									borderColor: rgba(colors.secondary.main, 0.18),
									whiteSpace: "nowrap",
								}}
							>
								View Hierarchy
							</MDButton>
          </Stack>
        </Stack>

        <Grid container spacing={2} mb={3}>
          {summaryCards.map((card) => (
            <Grid item xs={12} sm={6} xl={3} key={card.label}>
              <Card
                onClick={card.onClick}
                sx={{
                  p: 2.25,
                  borderRadius: "22px",
                  cursor: card.onClick ? "pointer" : "default",
                  border: `1px solid ${ui.border}`,
                  background: ui.summaryCard,
                  transition: "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
                  "&:hover": card.onClick
                    ? {
                        transform: "translateY(-2px)",
                        boxShadow: `0 14px 30px ${rgba(colors.dark.main, 0.08)}`,
                        borderColor: rgba(colors.info.main, 0.18),
                      }
                    : undefined,
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <MDBox>
                    <MDTypography
                      variant="body2"
                      sx={{
                        color: ui.summaryLabel,
                        textTransform: "uppercase",
                        letterSpacing: "0.06rem",
                        fontWeight: 600,
                      }}
                    >
                      {card.label}
                    </MDTypography>
                    <MDTypography
                      variant="h3"
                      sx={{ color: ui.summaryValue, mt: 0.75 }}
                    >
                      {card.value}
                    </MDTypography>
                    <MDTypography variant="body2" sx={{ color: ui.summaryMeta, opacity: darkMode ? 0.9 : 0.82, maxWidth: 620 }}>
                      {card.meta}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "14px",
                      backgroundColor: ui.iconSurface,
                      display: "grid",
                      placeItems: "center",
                    }}
                  >
                    {card.icon}
                  </MDBox>
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={2.5} mb={3}>
          <Grid item xs={12} xl={8}>
            <Grid container spacing={2.5}>
							
              <Grid item xs={12} lg={12}> 
                <Card sx={{ p: 2.5, borderRadius: "24px", border: `1px solid ${ui.border}`, backgroundColor: ui.card }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <MDTypography variant="h5" sx={{ color: ui.title }}>
                      Announcement/Notifications
                    </MDTypography>
                    {permissions?.includes(
                      modulePermissions?.notification_create_permission
                    ) && (
                      <IconButton
                        onClick={() => setAddNoticeDialogOpen(true)}
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: "14px",
                          backgroundColor: rgba(colors.error.main, 0.12),
                          color: colors.error.main,
                          "&:hover": {
                            backgroundColor: rgba(colors.error.main, 0.18),
                          },
                        }}
                      >
                        <Add />
                      </IconButton>
                    )}
                  </Stack>

                  {!filteredNotices.length ? (
                    <MDBox
                      sx={{
                        minHeight: 220,
                        display: "flex",
												flexDirection:'column',
                        placeItems: "center",
												justifyContent:'center',
												backgroundColor : ui.softAlt,
												borderRadius : "14px"
                      }}
                    >
                          <MDTypography variant='h5' color={ui.title}>No announcements or notifications available</MDTypography>
                          <MDTypography variant='body2' sx={{ color: ui.body }}>Please check back later for more updates!!!</MDTypography>
                    </MDBox>
                  ) : (
                    <Stack spacing={1.25}
										  sx={{display : 'flex', justifyContent:"center", flexDirection : 'column', overflowY : 'auto', whitespace : 'nowrap', height : '220px',
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    }
                  }}
										>
                      {filteredNotices.slice(0, 5).map((notice) => (
                        <MDBox
                          key={notice.id}
                          sx={{
                            p: 1.5,
                            borderRadius: "18px",
                            backgroundColor: ui.soft,
                            border: `1px solid ${ui.border}`,
                          }}
                        >
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            spacing={2}
                          >
                            <MDBox
                              sx={{ minWidth: 0, cursor: "pointer" }}
                              onClick={() => openNoticeDialog(notice)}
                            >
                              <Typography
                                variant="body1"
                                sx={{ color: ui.title, fontWeight: 700 }}
                              >
                                {notice.titile}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ color: ui.body, display: "block", mb: 0.5 }}
                              >
                                {moment(notice.created_at).format("DD MMM YYYY, hh:mm A")}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                {decodeHtml(stripHtml(notice.body || "")).substring(0, 140)}
                                {decodeHtml(stripHtml(notice.body || "")).length > 140 ? "..." : ""}
                              </Typography>
                            </MDBox>

                            {permissions?.includes(
                              modulePermissions?.notification_create_permission
                            ) && (
                              <IconButton
                                onClick={() => deleteNotice(notice.id)}
                                sx={{ alignSelf: "flex-start" }}
                              >
                                <Delete sx={{ color: colors.error.main, fontSize: 18 }} />
                              </IconButton>
                            )}
                          </Stack>
                        </MDBox>
                      ))}
                    </Stack>
                  )}
                </Card>
              </Grid>
							
            </Grid>
          </Grid>

          <Grid item xs={12} xl={4}>
            <Grid container spacing={2.5}>
              <Grid item xs={12}>
                <Card sx={{ p: 2.25, borderRadius: "24px", border: `1px solid ${ui.border}`, backgroundColor: ui.card }}>
                  <MDTypography variant="h5" sx={{ color: ui.title, mb: 1.5 }}>
                    Upcoming Leaves
                  </MDTypography>
                  <Stack spacing={1.2} 
									   sx={{display : 'flex', justifyContent: "start", flexDirection : 'column', overflowY : 'auto', whitespace : 'nowrap', height : '195px',
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    }
                  }}
									>
                    {(userDashboard?.upcoming_leaves_next_8_days || []).slice(0, 6).map((leave, index) => (
											<MDBox key={`${leave.employee__user__firstname}-${index}`}
                        //direction="row"
												display="flex"
                        spacing={1.2}
                        alignItems="center"
												gap = {2}
												overflowY = "scroll"
												whiteSpace = "nowrap"
												>
                      {/*<Stack
											   
                        key={`${leave.employee__user__firstname}-${index}`}
                        direction="row"
                        spacing={1.2}
                        alignItems="center"
												
                      >*/}
                        <MDBox
                          sx={{
                            minWidth: 45,
                            borderRadius: "10px",
                            overflow: "hidden",
                            border: `1px solid ${rgba(colors.warning.main, 0.18)}`,
                          }}
                        >
                          <MDBox
                            sx={{
                              backgroundColor: colors.warning.main,
                              color: colors.white.main,
                              textAlign: "center",
                              py: 0.3,
                              fontSize: "0.62rem",
                              fontWeight: 800,
                              textTransform: "uppercase",
                            }}
                          >
                            {moment(leave.start_date).format("MMM")} 
                          </MDBox>
                          <Typography
                            variant="body2"
                            sx={{
                              textAlign: "center",
                              py: 0.45,
                              color: ui.title,
                              fontWeight: 800,
                            }}
                          >
                            {moment(leave.start_date).format("DD") === moment(leave.end_date).format("DD") ? moment(leave.start_date).format("DD") : `${moment(leave.start_date).format("DD")}-${moment(leave.end_date).format("DD")}`}
                          </Typography>
                        </MDBox>
                        <MDBox sx={{ minWidth: 0, display: "flex", justifyContent:'space-between', width:"100%", alignItems: 'center' }}>
                          <Typography
                            variant="body2"
                            sx={{ color: ui.title, fontWeight: 700 }}
                          >
                            {leave.employee__user__firstname}{" "}
                            {leave.employee__user__lastname}
                          </Typography>
                          <Chip
                            size="small"
                            label={leave.status}
                            color={statusToColor[leave.status] || "default"}
                            sx={{ mt: 0.4, textTransform: "capitalize", height: 22, color: colors.light.main }}
                          />
                        </MDBox>
                      {/*</Stack>*/}
											</MDBox>
                    ))}

                    {!userDashboard?.upcoming_leaves_next_8_days?.length && (
                      <MDBox
                        sx={{
                          minHeight: 210,
                          display: "grid",
                          alignItems: "center",
													justifyContent: 'center',
													backgroundColor : ui.softAlt,
													borderRadius: "14px",
                        }}
                      >
                        <MDTypography variant='h6' color={ui.title}>No leaves for the upcoming days!!</MDTypography>
                      </MDBox>
                    )}
                  </Stack>

										<MDBox  pt={2} sx={{position : 'relative', backgroundColor : ui.card}}>
                      <Grid container spacing={1.2}>
                        <Grid item>{colorCodeComponent("approved")}</Grid>
                        <Grid item>{colorCodeComponent("pending")}</Grid>
                        <Grid item>{colorCodeComponent("rejected")}</Grid>
                      </Grid>
                    </MDBox>
                </Card>
              </Grid>

            </Grid>
          </Grid>
        </Grid>

					<Grid marginTop={2}>
						<Grid item xs={12}>
							<Calendar employees={employees} holidays={holidayEvents} />
						</Grid>
					</Grid>
      </MDBox>
			</Card>

      <Drawer
        anchor="right"
        open={hierarchyDrawerOpen}
        onClose={() => setHierarchyDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 420 },
            maxWidth: "100vw",
            backgroundColor: ui.card,
            backgroundImage: "none",
            borderLeft: `1px solid ${ui.border}`,
            boxShadow: `-24px 0 48px ${rgba(colors.dark.main, 0.12)}`,
          },
        }}
      >
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <MDBox
            sx={{
              px: 2.5,
              py: 2.25,
              borderBottom: `1px solid ${ui.border}`,
              background: darkMode
                ? `linear-gradient(180deg, ${rgba(palette.background.muted, 0.95)} 0%, ${rgba(
                    palette.background.card,
                    0.98
                  )} 100%)`
                : `linear-gradient(180deg, ${rgba(colors.info.light, 0.5)} 0%, ${rgba(
                    colors.white.main,
                    0.92
                  )} 100%)`,
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
              <MDBox>
                <MDTypography variant="h5" sx={{ color: ui.title, mb: 0.5 }}>
                  Reporting Hierarchy
                </MDTypography>
                <MDTypography variant="body2" color="text">
                  View the organization structure without leaving the dashboard.
                </MDTypography>
              </MDBox>
              <IconButton onClick={() => setHierarchyDrawerOpen(false)}>
                <Close />
              </IconButton>
            </Stack>
          </MDBox>

          <MDBox sx={{ flex: 1, overflowY: "auto", px: 2, py: 2 }}>
            <Stack spacing={1}>
              {/*{hierarchyItems.map((employee, index) => (
                <Stack
                  key={employee.id}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    px: 1.25,
                    py: 1.1,
                    borderRadius: "18px",
                    backgroundColor:
                      index === 0 ? rgba(colors.info.light, 0.7) : colors.white.main,
                    border: `1px solid ${rgba(colors.secondary.main, 0.1)}`,
                  }}
                >
                  <Stack direction="row" spacing={1.1} alignItems="center" minWidth={0}>
                    <MDBox
                      sx={{
                        width: 9,
                        height: 9,
                        borderRadius: "50%",
                        backgroundColor: index === 0 ? colors.info.main : colors.background.muted,
                        ml: employee.level * 1.5,
                        flexShrink: 0,
                      }}
                    />
                    <Avatar
                      src={normalizeImage(employee.img)}
                      sx={{
                        width: 34,
                        height: 34,
                        bgcolor: colors.background.accent,
                        color: colors.info.focus,
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      {employee.fullname?.charAt(0)}
                    </Avatar>
                    <MDBox sx={{ minWidth: 0 }}>
                      <Typography
                        variant="body2"
                        sx={{ color: colors.dark.main, fontWeight: 700 }}
                        noWrap
                      >
                        {employee.fullname}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: colors.secondary.main,
                          textTransform: "uppercase",
                          letterSpacing: "0.06em",
                        }}
                      >
                        {employee.level === 0 ? "Top level" : `Level ${employee.level}`}
                      </Typography>
                    </MDBox>
                  </Stack>
                  <East sx={{ color: colors.secondary.main, fontSize: 16 }} />
                </Stack>
              ))}*/}

              {/*{!hierarchyItems.length && (
                <MDBox
                  sx={{
                    minHeight: 220,
                    display: "grid",
                    placeItems: "center",
                  }}
                >
                  <MDTypography color="text">No hierarchy data available.</MDTypography>
                </MDBox>
              )}*/}
							{renderTree(orgHierarchy)}
            </Stack>
          </MDBox>
        </MDBox>
      </Drawer>

      <Dialog
        open={noticeDialogOpen}
        onClose={() => setNoticeDialogOpen(false)}
        PaperProps={{
          sx: {
            width: "min(720px, 92vw)",
            borderRadius: "24px",
            p: 1,
          },
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          px={2}
          pt={1}
        >
          <DialogTitle sx={{ p: 0, color: colors.dark.main, fontWeight: 800 }}>
            Announcement
          </DialogTitle>
          <IconButton onClick={() => setNoticeDialogOpen(false)}>
            <Close />
          </IconButton>
        </Stack>
        <DialogContent>
          <MDTypography
            sx={{
              fontSize: "15px",
              color: colors.dark.focus,
              "& img": {
                width: "25px",
                height: "25px",
                verticalAlign: "middle",
              },
            }}
          >
            {parse(noticeDialogData?.body || "")}
          </MDTypography>
        </DialogContent>
      </Dialog>

      <Dialog
        open={addNoticeDialogOpen}
        onClose={() => setAddNoticeDialogOpen(false)}
        PaperProps={{
          sx: {
            width: "min(760px, 94vw)",
            maxWidth: "none",
            minHeight: 420,
            borderRadius: "24px",
            p: 1,
          },
        }}
      >
        <DialogTitle sx={{ color: darkMode ? colors.light.main :colors.dark.main, fontWeight: 800 }}>
          Add Notice
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} alignItems="end">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Title"
                value={addNoticePayload?.titile || ""}
                onChange={(event) =>
                  setAddNoticePayload((state) => ({
                    ...state,
                    titile: event.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={["draft", "publish", "deactivated"]}
                onChange={(event, newValue) =>
                  setAddNoticePayload((state) => ({
                    ...state,
                    status: newValue,
                  }))
                }
                renderInput={(params) => <TextField {...params} label="Status" />}
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 2.5 }} />

          <MDEditor
            onChange={(value) => {
              setAddNoticePayload((state) => ({ ...state, body: value }));
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton
            variant="outlined"
            color="secondary"
            onClick={() => setAddNoticeDialogOpen(false)}
          >
            Cancel
          </MDButton>
          <MDButton variant="gradient" color="info" onClick={postNotice}>
            Create
          </MDButton>
        </DialogActions>
      </Dialog>

      <Popover
        open={Boolean(leaveAnchorEl)}
        anchorEl={leaveAnchorEl}
        onClose={() => setLeaveAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: ui.card,
            border: `1px solid ${ui.border}`,
            borderRadius: "20px",
            mt: 1,
          },
        }}
      >
        {renderEmployeePopover(
          todayLeaves,
          resolveDashboardEmployee,
          {
            secondaryText: (entry) =>
              `${moment(entry?.start_date).format("DD MMM")} - ${moment(entry?.end_date).format(
                "DD MMM"
              )}`,
          }
        )}
      </Popover>

      <Popover
        open={Boolean(wfhAnchorEl)}
        anchorEl={wfhAnchorEl}
        onClose={() => setWFHAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: ui.card,
            border: `1px solid ${ui.border}`,
            borderRadius: "20px",
            mt: 1,
          },
        }}
      >
        {renderEmployeePopover(
          todayWFHEmployees,
          resolveDashboardEmployee,
          {
            secondaryText: (entry) => `WFH on ${moment(entry?.date || todayKey).format("DD MMM YYYY")}`,
          }
        )}
      </Popover>

      <Popover
        open={Boolean(upcomingLeaveAnchorEl)}
        anchorEl={upcomingLeaveAnchorEl}
        onClose={() => setUpcomingLeaveAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: ui.card,
            border: `1px solid ${ui.border}`,
            borderRadius: "20px",
            mt: 1,
          },
        }}
      >
        {renderEmployeePopover(
          upcomingLeaves,
          resolveDashboardEmployee,
          {
            secondaryText: (entry) =>
              `${moment(entry?.start_date).format("DD MMM")} - ${moment(entry?.end_date).format(
                "DD MMM"
              )}`,
          }
        )}
      </Popover>
    </>
  );
}

export default EmployeeDashboard;
